<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/frm",
		    "name": "Fraud & Risk Management"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
      <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <ul class="breadcrumbsul">
                  <li><a href="#">Home</a></li>
                  <li>></li>
                  <li>Fraud & Risk Management</li>
              </ul>
          </div>
      </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}} </h2>
        </div>
      </div>
    </div>
</div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                  <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div  class="row align-items-center">
      <div class="col-lg-6 order-md-first ">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/about/realtime-protection1.webp" alt="Digital & Financial transaction mobile security App" class="og_image_url">
            <!-- <div class="play-btn">
              <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i class="fa fa-play"></i></a>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 ">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <!-- <span style="color: #da2b27;">Protectt.ai FRM in Payment Industry</span> -->
              <h2>The driving factor of trust and customer satisfaction</h2>
            </div>
            <p>At the current age of digitally transformed world the
              payments and other financial transactions are increasingly
              moving to Mobile Apps. India particularly witnessing a
              paradigm shift in Mobile App based Banking especially UPI
              Payments. While the ease of doing payments and billing have
              been instigated; the number of fraudulent transactions are
              still growing. For new customers, the resisting factors to adopt
              new age payment approach would be - How secured the eco
              system is?</p>
            <p>For payment service providers reliable and comprehensive
              decision making FRM is the key to predict the fraudulent
              transactions and prevent financial and reputational loss. </p>
            <!-- <p>MProtectt™ helps you secure your employees mobile device and at the same time safeguard your data integrity.</p>
            <p>MProtectt™ provides your business and employees the flexibility to operate anywhere and access email without containerization.</p> -->
            <div class="content text-left">
              <!-- <a href="mailto:sales@protectt.ai" class="btn contact-btn mt-30 btn-circle">Get in touch</a> -->
              <a href="mailto:sales@protectt.ai" class="btn contact-btn mt-30 btn-rectangle">Get in touch</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pre></pre>

  </div>
</div>
<!-- End Agency Benefits Area -->


<!-- Start Testimonial Style -->
<!-- <div class="section-testimonial-carousel section-pt section-pb">
  <div class="container">
      <div class="row">
          <div class="col-lg-12">
              <div class="section-title text-center">
                  <h2>Our Clients Say</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore</p>
              </div>
          </div>
      </div>
        <ngx-slick-carousel class="carousel"
        #slickModal="slick-carousel"
        [config]="slideConfig"
        (init)="slickInit()"
        (breakpoint)="breakpoint()"
        (afterChange)="afterChange()"
        (beforeChange)="beforeChange()">
      <div ngxSlickItem *ngFor="let slide of slides" class="slide">
      <img src="{{ slide.img }}" alt="slide" width="100%">
      </div>
      </ngx-slick-carousel>
  </div>
</div> -->

<!-- End Testimonial Style -->

<!-- Start Real-Time-Protectt Offerings -->

<div class="section-service section-pb-60">
  <div class="container">
    <div class="row">
      <div  class="col-lg-12">
        <div class="section-title text-center">
          <h2>RealTime Protectt Offerings</h2>
        </div>
      </div>
    </div>
    <ngx-slick-carousel  class="carousel newcard" #slickModal="slick-carousel" [config]="slideConfig"
      (init)="slickInit()" (breakpoint)="breakpoint()" (afterChange)="afterChange()" (beforeChange)="beforeChange()">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
          <!-- <img src="{{ slide.img }}" alt="slide" width="90%" height="180px"> -->
          <div class="card height-180px my-0 mx-2">
            <div class="card-body d-flex align-items-center text-uppercase justify-content-center text-center">
              <h4 class="card-title">{{slide.text}}</h4>
            </div>
          </div>
        </div>
    </ngx-slick-carousel>
  </div>
  <div  class="content text-center">
    <!-- <a routerLink="/realtime-protectt" class="btn contact-btn mt-30 btn-circle">Explore RealTime Protectt</a> -->
    <a routerLink="/realtime-protectt" class="btn contact-btn mt-30 btn-rectangle">Explore RealTime Protectt</a>
  </div>
</div>

<!-- End Real-Time-Protectt Offerings -->

<!-- Start Cyber Security Needs -->
<!-- <div class="section-service section-pt section-pb-60">
  <div class="container">
      <div class="row">
          <div class="col-lg-12">
              <div style="margin-bottom: 0;" class="section-title text-center">
                  <h2>Discuss Your Cyber Security Needs Today</h2>
              </div>
          </div>
      </div>
      <div class="header-btn text-center">
          <a href="#" class="btn contact-btn mt-30 btn-circle">Request a Demo</a>
          <a href="#" class="btn contact-btn mt-30 btn-circle">Start a Free Trial</a>
          <a href="#" class="btn contact-btn mt-30 btn-circle">Contact Sales</a>
      </div>
  </div>
</div> -->

<!-- End Cyber Security Needs -->
